module.exports = __webpack_public_path__ + "media/public/images/social/whatsup-hover-6073ce4ef58e56f446514e98277bfbf8.svg";